export default
{
  'draggedItem': null,
  'cardItems': [],
  'standardGridItems': [],
  'featuredCarouselItems': [],
  'linkItems': [],
  'widgetType': 'none',
  'menuContent': {
    'Menu Items': [
      {
        'linkText': 'New Item',
        'type': 'item',
        'id': 0
      },
      {
        'linkText': 'New Container',
        'type': 'container',
        'id': 1,
        'columns': []
      }
    ]
  },
  'socialLinks': [
    {'title': 'facebook', 'url': 'https://'},
    {'title': 'vimeo', 'url': 'https://'},
    {'title': 'linkedin', 'url': 'https://'},
    {'title': 'twitter', 'url': 'https://'},
    {'title': 'google-plus', 'url': 'https://'},
    {'title': 'youtube', 'url': 'https://'},
    {'title': 'skype', 'url': 'https://'},
    {'title': 'pinterest', 'url': 'https://'},
    {'title': 'instagram', 'url': 'https://'},
    {'title': 'trip-advisor', 'url': 'https://'},
    {'title': 'tiktok', 'url': 'https://'}
  ],
  'widgetSettings': {
    'listType': 'events',
    'linkColor': '#AB149E',
    'linkHeadline': '',
    'linkHeadlineColor': '#000000',
    'linkListCollapsible': true,
    'linkIcon': null,
    'linkIconColor': '#AB149E',
    'linkIconPosition': 'left',
    'maxItems': 3,
    'newsLayout': [2, 2],
    'maxCharacters': 126,
    'layoutSettings': {
      '1': 2,
      '2': 3
    },
    'selectedWidget': 'carousel',
    'socialIconStyle': 'branded',
    'carouselSettings': {
      'fade': {
        'text': 'Fade between slides',
        'type': 'radio',
        'value': true
      },
      'loop': {
        'text': 'Loop through slides',
        'type': 'radio',
        'value': true
      },
      'delay': {
        'text': 'Delay between Slides',
        'type': 'input',
        'value': 1000
      },
      'pills': {
        'text': 'Display Progress pills',
        'type': 'radio',
        'value': true,
        'values': true
      },
      'arrows': {
        'text': 'Display left & right arrows',
        'type': 'radio',
        'value': true
      },
      'autoplay': {
        'text': 'Autoplay carousel slides',
        'type': 'radio',
        'value': true
      }
    },
    'wysiwygContent': 'This space is intentionally left blank.',
    videoSettings: {
      additionalClasses: '',
      width: 'full-width',
      'background_video': {
        'video_mp4': ''
        // 'video_webm': ''
      },
      displayPopupVideo: false,
      // Iframe video
      'video_link': {
        'player': 'youtube',
        'video_url': ''
      },
      videoFocus: 'centered',
      // In the event of a fallback or disable motion stuff.
      'video_placeholder_background': {
        opmode: 'filestore',
        url: '',
        fileStore: { // img
          fileStoreID: '',
          filepath: '',
          filestorename: '',
          preset: '',
          file: {
            name: '',
            description: '',
            mimeType: '',
            created: '',
            size: 0,
            tags: []
          }
        }
      },
      'videoTint': 20,
      'video_aspect_ratio': 'fluid',
      'BannerVerticalPosition': 'video-banner-content-vertical-position-centered',
      'BannerHorizontalPosition': 'video-banner-content-horizontal-position-centered',
      'BannerTextAlignment': 'video-banner-text-center',
      'title': 'Example Title.',
      'leadline': '',
      'description': 'A brief and concise statement that outlines the main points of the banner.',
      'banner_graphic': {
        enabled: false,
        imageSize: 'medium',
        imageSizeCustomWidth: 50,
        image: {
          opmode: 'filestore',
          url: '',
          fileStore: {
            fileStoreID: '',
            filepath: '',
            preset: '',
            name: '',
            file: {
              name: '',
              description: '',
              mimeType: '',
              created: '',
              size: 0,
              tags: []
            }
          }
        }
      },
      // In the event that the client wants to whole banner to
      // be clickable, this will output a link for the video.
      // Add target_blank setting
      'fullBannerLink': {
        'linkUrl': ''
      },
      hasPrimaryAction: false,
      primaryAction: {
        'buttonSize': 'standard',
        'buttonType': 'square',
        'buttonIcon': '',
        'buttonIconPosition': 'right',
        'buttonIconSize': 'standard',
        'buttonStyle': 'solid',
        'linkUrl': '',
        'linkText': 'Learn More.'
      },
      hasSecondaryAction: false,
      secondaryAction: {
        'buttonSize': 'standard',
        'buttonType': 'square',
        'buttonIcon': '',
        'buttonIconPosition': 'right',
        'buttonIconSize': 'standard',
        'buttonStyle': 'solid',
        'linkUrl': '',
        'linkText': 'Learn More.'
      }
    },
    standardGrid: {
      gridGap: 1,
      gridColumns: {
        small: 2,
        medium: 2,
        large: 4
      },
      imageAspectRatio: '1-1'
    },
    featuredCarousel: {},
    saveAllowed: true
  },
  'defaultSystemCards': {
    wysiwyg: [
      {
        cardSystemDefault: true,
        cardType: 'wysiwyg',
        cardName: 'Wysiwyg Card',
        cardTitle: 'Wysiwyg Content',
        cardDescription: 'Lorem ipsum dolor sit amet'
      }
    ],
    photo: [
      {
        cardSystemDefault: true,
        cardType: 'photo',
        cardName: 'Photo Card 1',
        cardTitle: 'Awesome Headline 1',
        cardTextAlign: 'left',
        cardVerticalTextAlign: 'center',
        cardTextShadow: '',
        cardDescription: 'Just a little bit of text here and there',
        cardBackgroundUrl: 'https://images.unsplash.com/photo-1536168708735-971ef4b5f80e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=4a15b06189e4c5530f174f990da9bf13&auto=format&fit=crop&w=2089&q=80',
        cardBackgroundTinting: 20,
        cardButtonPrimaryText: '',
        cardButtonPrimaryUrl: '',
        cardButtonPrimaryTargetBlank: false,
        cardButtonSecondaryText: '',
        cardButtonSecondaryUrl: '',
        cardButtonSecondaryTargetBlank: false,
        opmode: 'filestore',
        url: '',
        fileStore: {
          fileStoreID: '',
          filepath: '',
          preset: '',
          file: {
            name: '',
            description: '',
            mimeType: '',
            created: '',
            size: 0,
            tags: []
          }
        }
      }
    ],
    icon: [
      {
        cardSystemDefault: true,
        cardType: 'icon',
        cardName: 'Icon Card 1',
        cardTitle: 'Awesome Headline 1',
        cardTextAlign: 'left',
        cardIconPosition: 'left',
        cardTextShadow: '',
        cardIconDropShadow: false,
        cardDescription: 'Just a little bit of text here and there',
        cardBackgroundUrl: 'https://www.motormeister.com.au/templates/motormeister/images/icons/why_choose_us.svg',
        cardBackgroundColor: {
          hsl: {},
          hex: '#FFFFFF',
          rgba: {},
          hsv: {},
          oldHue: null,
          source: 'hex',
          rgbaString: 'rgba(255,255,255,1)'
        },
        cardTextColor: {
          hsl: {},
          hex: '#000000',
          rgba: {},
          hsv: {},
          oldHue: null,
          source: 'hex',
          rgbaString: 'rgba(0,0,0,1)'
        },
        cardBackgroundTinting: 20,
        cardButtonPrimaryText: '',
        cardButtonPrimaryUrl: '',
        cardButtonPrimaryTargetBlank: false,
        cardButtonSecondaryText: '',
        cardButtonSecondaryUrl: '',
        cardButtonSecondaryTargetBlank: false,
        opmode: 'filestore',
        url: '',
        fileStore: {
          fileStoreID: '',
          filepath: '',
          preset: '',
          file: {
            name: '',
            description: '',
            mimeType: '',
            created: '',
            size: 0,
            tags: []
          }
        }
      }
    ],
    color: [
      {
        cardSystemDefault: true,
        cardType: 'color',
        cardName: 'Color Card 1',
        cardTitle: 'Awesome Headline 1',
        cardDescription: 'Just a little bit of text here and there',
        cardBackgroundColor: {
          hsl: {},
          hex: '#FFFFFF',
          rgba: {},
          hsv: {},
          oldHue: null,
          source: 'hex',
          rgbaString: 'rgba(123,100,255,1)'
        },
        cardTextColor: {
          hsl: {},
          hex: '#000000',
          rgba: {},
          hsv: {},
          oldHue: null,
          source: 'hex',
          rgbaString: 'rgba(255,255,255,1)'
        },
        cardTextAlign: 'left',
        cardVerticalTextAlign: 'center',
        cardButtonPrimaryText: '',
        cardButtonPrimaryUrl: '',
        cardButtonPrimaryTargetBlank: false,
        cardButtonSecondaryText: '',
        cardButtonSecondaryUrl: '',
        cardButtonSecondaryTargetBlank: false
      }
    ],
    video: [
      {
        cardSystemDefault: true,
        cardType: 'video',
        cardName: 'Video Card 1',
        cardTitle: 'Awesome Headline 1',
        cardDescription: 'Just a little bit of text here and there',
        cardVideoUrl: 'https://www.youtube.com/embed/OfAGFbUkZ-g'
      }
    ]
  }
}
